import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSpinLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowSpinLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M20.527 20.582a.9.9 0 0 1-1.8 0v-.617c-.732.701-1.666 1.252-2.6 1.65-1.753.744-3.832 1.095-5.444.814-2.919-.51-4.852-1.634-5.61-2.392a.9.9 0 0 1 1.27-1.274c.428.426 1.983 1.427 4.648 1.892 1.18.206 2.903-.048 4.432-.698 1.08-.459 1.912-1.047 2.407-1.67l-1.357.259a.9.9 0 1 1-.337-1.768l3.322-.634 1.07-.205zM12.22 7.84a4.19 4.19 0 0 1 3.972 4.182l-.006.215a4.19 4.19 0 0 1-4.182 3.972l-.216-.005a4.189 4.189 0 0 1 .216-8.37zm-.216 1.794a2.389 2.389 0 1 0 0 4.777 2.389 2.389 0 0 0 0-4.777M7.898 2.428c1.753-.745 3.833-1.096 5.445-.815 2.918.51 4.851 1.634 5.61 2.392a.9.9 0 0 1-1.271 1.274c-.427-.426-1.982-1.427-4.648-1.892-1.18-.206-2.902.048-4.431.698-1.08.458-1.913 1.047-2.408 1.67l1.358-.259a.9.9 0 1 1 .337 1.768l-3.323.634-1.069.206V3.46a.9.9 0 0 1 1.8 0v.617c.733-.701 1.666-1.252 2.6-1.65"
            />
        </svg>
    );
}
export default memo(IconArrowSpinLeft24);
